import { IChecklist, ITask } from './'
import { IPaginatedRequest } from '../../request'

export const listChecklists = (params: IPaginatedRequest) => ({
  method: 'GET',
  url: '/modules/checklists',
  params
})

export const getChecklist = (UUID: string) => ({
  method: 'GET',
  url: `/modules/checklists/${UUID}`
})

export const createChecklist = (data: Partial<IChecklist>) => ({
  method: 'POST',
  url: '/modules/checklists',
  data
})

export const updateChecklist = (UUID: string, data: Partial<IChecklist>) => ({
  method: 'PUT',
  url: `/modules/checklists/${UUID}`,
  data
})

export const regenerateChecklist = (UUID: string, data: Partial<IChecklist>) => ({
  method: 'PUT',
  url: `/modules/checklists/${UUID}/regenerate`,
  data
})

export const removeChecklist = (UUID: string, data: { dryRun: boolean }) => ({
  method: 'DELETE',
  url: `/modules/checklists/${UUID}`,
  data
})

export const getChecklistTasks = (UUID: string, params: IPaginatedRequest) => ({
  method: 'GET',
  url: `/modules/checklists/${UUID}/tasks`,
  params
})

export const updateChecklistTask = (UUID: string, taskUUID: string, data: Partial<ITask>) => ({
  method: 'PUT',
  url: `/modules/checklists/${UUID}/tasks/${taskUUID}`,
  data
})
